// src/pages/conversaciones/components/ChatHeader.tsx
import { Link } from 'react-router-dom';
import { Avatar, StatusBadge, Button } from '@/components/ui';
import { ArrowLeft, Pause, Play, XCircle } from 'lucide-react';
import type { Conversacion } from '@/types';
import {
  usePausarConversacion,
  useReanudarConversacion,
  useCerrarConversacion,
} from '@/hooks/queries/useConversaciones';

interface Props {
  conversacion: Conversacion;
}

export function ChatHeader({ conversacion }: Props) {
  const pausar = usePausarConversacion();
  const reanudar = useReanudarConversacion();
  const cerrar = useCerrarConversacion();

  const handlePausar = () => {
    pausar.mutate({ id: conversacion.id, data: {} });
  };

  const handleReanudar = () => {
    reanudar.mutate(conversacion.id);
  };

  const handleCerrar = () => {
    if (confirm('Esta seguro de cerrar esta conversacion?')) {
      cerrar.mutate(conversacion.id);
    }
  };

  return (
    <div className="flex items-center justify-between p-4 border-b">
      <div className="flex items-center gap-4">
        <Link to="/conversaciones" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <Avatar fallback={conversacion.cliente?.nombre} size="md" />
        <div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">{conversacion.cliente?.nombre}</span>
            <StatusBadge status={conversacion.estado} />
          </div>
          <p className="text-sm text-gray-500">{conversacion.asunto || 'Sin asunto'}</p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        {conversacion.estado === 'EN_PAUSA' ? (
          <Button
            variant="outline"
            size="sm"
            onClick={handleReanudar}
            loading={reanudar.isPending}
          >
            <Play className="h-4 w-4 mr-1" />
            Reanudar
          </Button>
        ) : (
          conversacion.estado !== 'CERRADA' && (
            <Button
              variant="outline"
              size="sm"
              onClick={handlePausar}
              loading={pausar.isPending}
            >
              <Pause className="h-4 w-4 mr-1" />
              Pausar
            </Button>
          )
        )}

        {conversacion.estado !== 'CERRADA' && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleCerrar}
            loading={cerrar.isPending}
          >
            <XCircle className="h-4 w-4 mr-1" />
            Cerrar
          </Button>
        )}
      </div>
    </div>
  );
}
